<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card>
            <template slot="header">
              <h4 class="card-title">Diseases</h4>
              <!-- <p class="card-category">List of tasks</p> -->
              <p></p>

              <div class="row mt10">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="search" class="control-label">Search</label>
                    <input
                      id="search"
                      v-model="search"
                      v-on:keyup="filter($event)"
                      class="form-control"
                      placeholder="Type to search"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
                <div class="col-md-8">
                  <button type="submit" class="btn btn-success btn-fill float-right" @click.prevent="create">
                    Add new
                  </button>
                </div>
              </div>

              <!-- <div class="row mt10">
                                
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="field" class="control-label">Field</label>
                                        <v-select id="field" v-model="filters.field"  :clearable="false" :options="fields"></v-select>
                                    </div>
                                </div>

                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="equally" class="control-label">Equally</label>
                                        <v-select id="equally" v-model="filters.equally"  :clearable="false" :options="['none']"></v-select>
                                    </div>
                                </div>

                              
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <button type="submit" class="btn btn-success btn-fill "
                                            @click.prevent="get">
                                        Filter
                                        </button>

                                        <button type="submit" class="btn btn-warning btn-fill "
                                            @click.prevent="clearFilters">
                                        Clear
                                        </button>
                                    </div>
                                    
                                </div>

                            </div> -->
            </template>
            <div class="article-header">
              <div v-for="column in columns">
                <span v-if="column === 'order'">Order</span>
                <span v-else-if="column === 'preview_img'">Image</span>
                <span v-else-if="column === 'title'">Title</span>
                <span v-else-if="column === 'sub_title'">Subtitle</span>
                <span v-else-if="column === 'status'">Status</span>
                <span v-else-if="column === 'edit'"></span>
                <span v-else-if="column === 'remove'"></span>
                <span v-else>{{ column }}</span>
              </div>
            </div>
            <div>
              <drop-list :items="data" @reorder="onReorder">
                <template v-slot:item="{ item, reorder }">
                  <drag :disabled="Boolean(search.length)" :key="item.id" :data="item">
                    <div
                      v-if="item"
                      class="article-card"
                      :style="reorder ? { borderLeft: '4px solid #1976D2', marginLeft: '-4px' } : {}"
                    >
                      <slot :row="item">
                        <div v-for="column in columns">
                          <span v-if="column === 'preview_img'">
                            <img v-if="item[`preview_img`]" class="preview-img" v-bind:src="item[`preview_img`]" />
                          </span>
                          <span v-else-if="column === 'status'">
                            <span v-if="item.status === 0">Not active</span>
                            <span v-if="item.status === 1">Active</span>
                          </span>
                          <span v-else-if="column === 'title'">
                            <span :style="{ flex: '2 !important' }"> {{ item[`title`] }}</span>
                          </span>

                          <span v-else-if="column === 'edit'">
                            <button type="button" class="btn btn-danger" @click.prevent="() => editInfo(item.id)">
                              <i class="fas fa-edit"></i>
                            </button>
                          </span>
                          <span v-else-if="column === 'created_at'">
                            {{ item[column] | toEasyDate }}
                          </span>
                          <span v-else-if="column === 'remove'">
                            <button type="button" class="btn btn-danger" @click.prevent="() => remove(item.id)">
                              <i class="fas fa-trash-alt"></i>
                            </button>
                          </span>
                          <span v-else>{{ item[column] }}</span>
                        </div>
                      </slot>
                    </div>
                  </drag></template
                ></drop-list
              >
            </div>
            <div
              :class="{ disabled: data.length < limit }"
              class="pagination-button btn btn-warning btn-fill float-right"
              @click.prevent="next"
            >
              Next
            </div>
            <div
              :class="{ disabled: offset < limit }"
              class="pagination-button btn btn-warning btn-fill float-right"
              @click.prevent="prev"
            >
              Previous
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const _ = require('lodash')
const axios = require('axios')
import LTable from 'src/components/UIComponents/Table.vue'
import Card from 'src/components/UIComponents/Cards/Card.vue'
import moment from 'moment'
import { Drag, Drop, DropList } from 'vue-easy-dnd'

export default {
  components: {
    LTable,
    Card,
    Drag,
    DropList,
    Drop,
  },
  created: function() {
    this.get()

    document.title = `Diseases`
  },
  data() {
    return {
      columns: ['order', 'id', 'preview_img', 'title', 'sub_title', 'status', 'edit', 'remove'],
      data: [],
      limit: 100,
      offset: 0,
      search: '',
    }
  },
  filters: {
    toEasyDate(value) {
      return moment(String(value)).format('DD.MM.YYYY, HH:mm')
    },
    toShortText(value) {
      return value.length > 50 ? value.substr(0, 50) + '...' : value.substr(0, 50)
    },
  },
  methods: {
    clearFilters: function() {
      this.filters = {
        field: null,
        equally: 'none',
        value: '',
      }

      this.get()
    },
    filter: function(event) {
      console.log(this.search)
      if ((this.search && this.search.length >= 1) || this.search.length === 0) {
        this.get()
      }
    },
    onReorder(event) {
      this.reorder(event.from, event.to)
    },
    reorder: async function(from, to) {
      let token = localStorage.getItem('token')

      const movedItem = this.data.find((_i, index) => index === from)
      const remainingItems = this.data.filter((_i, index) => index !== from)

      const reorderedData = [...remainingItems.slice(0, to), movedItem, ...remainingItems.slice(to)]

      Promise.all(
        reorderedData.map(({ index, ...data }, idx) =>
          axios.post(
            `${this.$hostname}/admin/diseases/${data.id}/save`,
            { ...data, order: idx + 1 },
            {
              headers: {
                Authorization: token,
              },
            }
          )
        )
      ).finally(() => {
        this.get()
      })
    },
    get: function() {
      let self = this

      let token = localStorage.getItem('token')

      axios
        .get(`${this.$hostname}/admin/diseases`, {
          params: {
            ...(self.search && { search: self.search }),
            limit: this.limit,
            offset: this.offset,
          },
          headers: {
            Authorization: token,
          },
        })
        .then(function(response) {
          self.data = response.data.sort((a, b) => a.order - b.order)
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    prev: function() {
      if (this.offset >= this.limit) {
        this.offset -= this.limit
        this.get()
      }
    },
    next: function() {
      if (this.data.length === this.limit) {
        this.offset += this.limit
        this.get()
      }
    },
    saveFilters: function(name, value) {
      localStorage.setItem(name, value)
    },
    create: function() {
      let route = this.$router.resolve({ path: `/diseases/create` })
      window.open(route.href, '_blank')
    },
    editInfo: function(id) {
      let route = this.$router.resolve({ path: `/diseases/${id}` })
      window.open(route.href, '_blank')
    },
    remove: async function(id) {
      let token = localStorage.getItem('token')

      if (!confirm(`Are you sure?`)) {
        return false
      }

      await axios.post(
        `${this.$hostname}/admin/diseases/remove`,
        { id: id },
        {
          headers: {
            Authorization: token,
          },
        }
      )

      await this.get()
    },
  },
}
</script>
<style scoped>
.b {
  font-weight: 800 !important;
}
.pagination-button {
  height: 30px;
  padding: 1px 16px;
  margin-left: 20px;
  color: #fff !important;
}
.pagination-button.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.text-primary {
  cursor: pointer;
}

.wallpapers-preview {
  cursor: pointer;
  max-height: 200px;
}

.mt10 {
  margin-top: 10px;
}

.btn-fill {
  margin-top: 25px;
}
.premium {
  width: 30px;
  margin-left: 20px;
}

.device-block {
  position: relative;
  background-position: center center;
  background-size: cover;
  cursor: pointer;
}
.device-block img {
  width: 40px;
  height: 40px;
  position: absolute;
  right: 18px;
  top: 18px;
}
.device-block span {
  position: absolute;
  top: -30px;
  left: 5px;
}
.device1 {
  display: block;
  width: 92px;
  height: 200px;
  border: 3px solid #000;
  border-radius: 10px;
  margin-left: 30px;
}
.device2 {
  display: block;
  width: 112px;
  height: 200px;
  border: 3px solid #000;
  border-radius: 10px;
  margin-left: 20px;
}
.device3 {
  display: block;
  width: 150px;
  height: 200px;
  border: 3px solid #000;
  border-radius: 10px;
}
.mt30 {
  margin-top: 30px;
}
.color-block {
  display: block;
  width: 50px;
  height: 50px;
}

.article-header {
  width: 100%;
  display: flex;
  margin-left: 12px;
  margin-bottom: 12px;
}
.article-header > * {
  flex: 1;
}
.article-card {
  width: 100%;
  display: flex;
  align-items: center;
  border: 1px solid #c8c2c2;
  border-radius: 12px;
  padding: 18px 36px;
  margin-bottom: 12px;
  color: #3e3d3d;
}
.article-card > * {
  flex: 1;
}
.string-input {
  height: 35px;
}
.preview-img {
  width: 100px;
  height: 100px;
  /* margin-bottom: 20px; */
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Diseases/Diseases.vue